export default function AdminLogin({ busy, onSubmit, status }) {
  return (
    <main className="admin-page">
      <form className="admin-login" onSubmit={onSubmit}>
        <p className="admin-kicker">Website management</p>
        <h1>Admin login</h1>
        <label>Email<input name="email" type="email" autoComplete="username" required /></label>
        <label>Password<input name="password" type="password" autoComplete="current-password" required /></label>
        {status.message && <p className={`admin-message ${status.type}`} role="alert">{status.message}</p>}
        <button className="admin-primary" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
